import React, { Component } from 'react';
import './Study.css';
import Header from '../Header/Header';
import { withRouter } from "react-router";
import { withAuth } from "../../app/util/HOC";
import StudyCenterHeader from './StudyCenterHeader';
import { handleException } from "../../app/util/util";
import StudyCenterStudent from './StudyCenterStudent';
export class StudyCenterStudentPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 50,
            bookISBN: "",
            bookTitle: "",
            chapterVOList: null,
            chapterNavTitle: "",
            learningObjectiveProgressVOList: [],
            bookVO: JSON.parse(localStorage.getItem('bookVO')),
            userVO: JSON.parse(localStorage.getItem('userVO')),
            keepMeLogIn: localStorage.getItem('keepLoggedIn') ? "true" : "false",
        };
    }
    componentDidMount = () => {
        this.getChapterAndSupplementalList()
    }
    getChapterAndSupplementalList = () => {
        let reqData = {
            "userVO": {
                "userId": this.state.userVO.userId,
                "userRole": this.state.userVO.userRole,
                "userRoleId": this.state.userVO.userRoleId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "studycenter",
                    "pageNavigatingTo": "studycenter",
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken
                },
            },
            "bookVO": {
                "bookISBN": this.props.match.params.isbn
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/learningObjectiveRetrievalService/getChapterAndSupplementListForStudy", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.chapterVOList) {
                        data.chapterVOList = Array.isArray(data.chapterVOList) ? data.chapterVOList : [data.chapterVOList];
                        this.setState({ "chapterVOList": data.chapterVOList, "bookVO": data.bookVO });
                    }
                } else {
                    if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    render() {
        return (
            <React.Fragment>
                <Header userVO={this.state.userVO} bookVO={this.state.bookVO} pageName="study" ></Header>
                {
                    this.state.chapterVOList ?
                        <StudyCenterHeader userVO={this.state.userVO} chapterVOList={this.state.chapterVOList} />
                        : null
                }
                <StudyCenterStudent></StudyCenterStudent>
            </React.Fragment>
        )
    }
}
export default withAuth(withRouter(StudyCenterStudentPage));